export class ErrorMessage {
    constructor(
        public title: string,
        public text: string
    ) {}
}
